export const GOOGLEPLAY_LINK = "https://play.google.com/store/apps/details?id=com.iveitteam.wineup";
export const APPSTORE_LINK = "https://apps.apple.com/hu/app/mywineup/id6472480212?platform=iphone";